import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import newsService from "../../services/news.service";
import { ReactComponent as CrossIcon } from "../../assets/images/corss.svg";
import { ReactComponent as SaveIcon } from "../../assets/images/iconsave.svg";
import { ReactComponent as PenIcon } from "../../assets/images/iconknow.svg";
import { ReactComponent as ListIcon } from "../../assets/images/list.svg";
import defaultBanner from "../../assets/images/announcement/default.jpg"

import planningService from "../../services/planning.service";
import { minWidth } from '@mui/system';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
// swiper core styles
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'

// modules styles
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'
import imgNew from "../../assets/images/home/banner-image.svg";
import noDataNews from "../../assets/images/news/img_no_data.svg";
import * as Util from "../../services/global.service";

SwiperCore.use([Navigation]);

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const Announcement = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        // handleGetList()
        if (dataNews !== undefined && dataNews !== null && dataNews !== "null") {
            getNewsDataHome()
            getTagsList()
        }
    }, []);

    const useStyles = makeStyles({
        swiperStyles: {
            paddingTop: "10px !important"

        },
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        statusBadge: {
            maxWidth: "150px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
        },
        processBgGoals: {
            background: "#4085C9  !important",
            color: "#4085C9 !important",
            "&:hover": {
                backgroundColor: "#4085C9 !important",
            },
            "& > .MuiButton-root": {
                color: "none",
            }

        },

        styleTextSmall: {
            color: "##949494 !important",
            fontWeight: "600",
            fontSize: "12px",
            lineHeight: "15px",
        },

        processBgRubric: {
            background: "#85AEB0 !important",
        },

        processBgCompetency: {
            background: "#958CCB !important",
        },

        styleTextBtSmall: {
            color: "##949494 !important",
            fontWeight: "600",
            fontSize: "12px",
            lineHeight: "15px",
        },

    })
    const [dataNews, setDataNewsHome] = React.useState([]);
    const [dataTags, setListTag] = React.useState([]);

    let getNewsDataHome = () => {
        newsService.limit().then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setDataNewsHome(response.data)
                }


            },
        );
    }

    let getTagsHome = (tags) => {
        newsService.tags(tags).then(
            (response) => {
                navigate(`/kpi/announcement/typenews/${tags}`, { replace: false })
            },
        );
    }

    let getTagsList = () => {
        newsService.tagsList().then(
            (response) => {
                setListTag(response.data)
            },
        );
    }

    const item = props.item
    const handleGoToDetail = (e) => {
        navigate(`/kpi/announcement/contentnews/${e}`, { replace: false });
    }

    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const vBoxPadding = 2;
    const [List, setList] = React.useState([]);
    const handleGetList = () => {
        planningService.mainPlanning().then(
            (response) => {
                setList(response.data)
            },
        ).catch(() => {

        })
    };
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };



    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    pt: 3,
                    pb: 2,
                    width: '100%'
                }}
            >


                <Grid container >
                    <Grid item xs sm md lg pl={2}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }} >
                            <Box>
                                <Typography fontSize={24} lineHeight="26.4px" paddingBottom="14px" fontWeight="600" color="#404349">
                                    {t("news.label.news")}
                                </Typography>
                                <Typography fontSize={18} lineHeight="19.8px" fontWeight="400" color="#404349">
                                    {t("news.label.newTags")}
                                </Typography>
                                <Box sx={{ display: "flex", paddingTop: "20px" }}>

                                    {dataTags.map(itemname => (
                                        <Button onClick={() => getTagsHome(itemname)} sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '15px', padding: "5px 20px" }}
                                            className={classes.processBgGoals}>
                                            <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="14px" color="#FFFFFF" >
                                                {itemname}
                                            </Typography>
                                        </Button>
                                    )
                                    )

                                    }

                                </Box>
                            </Box>
                            <Box>
                                <Button sx={{ background: '#5DA196', "border-radius": '4px', padding: '6px 8px' }} variant="contained" onClick={() => navigate("/kpi/announcement/allnews", { replace: false })}>

                                    <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="24px" color="#FFFFFF">
                                        {t("news.label.readmore")}
                                    </Typography>

                                </Button>
                            </Box>
                        </Box>

                        {
                            dataNews.length > 0 ?

                                <Box sx={{ paddingTop: "20px", display: "flex", width: '100%' }}>


                                    {dataNews.map(item => {
                                        return (
                                            item.show_home === true ?

                                                <Box sx={{ background: '#FFFFFF', "box-shadow": '0px 0px 10px rgba(0, 0, 0, 0.1)', "border-radius": '10px', margin: '18px 10px', '&:last-child': { marginRight: '0px' }, '&:first-child': { marginLeft: '0px' }, width: "25%" }}>
                                                    <Box sx={{ padding: '20px 10px' }}>
                                                        <Box sx={{ borderRadius: '5px', height: '12.43vw', width: '100%', maxHeight: "179px" }}>
                                                            <img src={item.thumbnail !== "" ? item.thumbnail : defaultBanner} style={{ height: '100%', width: '100%', borderRadius: '5px' }} alt="banner">

                                                            </img>
                                                        </Box>
                                                        <Typography fontSize={20} lineHeight="30px" color="#404349" fontWeight={400} sx={{ wordBreak: "break-word", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical", paddingTop: "10px", cursor: 'pointer' }} onClick={() => handleGoToDetail(item.serial)}>
                                                            {formatData(item.title, "-")}
                                                        </Typography>

                                                        {/* <Box sx={{ display: "flex", paddingTop: "10px", flexFlow: "row wrap" }}>
                                                        {
                                                            item.tags.map(itemname => (
                                                                <Button sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '10px', marginTop: '5px', padding: "5px 10px" }}
                                                                    className={classes.processBgGoals}>
                                                                    <Typography fontSize={12} lineHeight="14px" color="#FFFFFF" >
                                                                        {itemname}
                                                                    </Typography>
                                                                </Button>
                                                            )
                                                            )
                                                        }
                                                    </Box> */}

                                                        <Typography fontSize={12} lineHeight="14px" fontWeight={400} color="#949494" sx={{ paddingTop: '10px' }}>
                                                            <span className={classes.styleTextBtSmall}>{formatData(item?.client, "-")}</span>  {Util.dateDayFormat(item?.start_at, "-")}
                                                        </Typography>
                                                    </Box>

                                                </Box>


                                                : null
                                        )
                                    }
                                    )
                                    }


                                </Box>
                                :
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '300px' }}>
                                    <Grid display='flex' justifyContent='center' flexDirection='column' alignItems='center' >
                                        <img src={noDataNews} style={{ maxWidth: '120px', maxHeight: '110px', height: '100%', width: '100%' }}>

                                        </img>
                                        <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="#949494" sx={{ paddingTop: '20px' }}>
                                            {t("news.label.noNews")}
                                        </Typography>
                                    </Grid>
                                </Box>
                        }

                    </Grid>
                </Grid>

            </Box>
        </>
    )
};
export default Announcement;



